export class DelayedPromise<Type> {
  promise: Promise<Type>;
  resolve: (value: Type) => void;
  reject: (reason: unknown) => void;

  constructor() {
    this.resolve = DelayedPromise.noop;
    this.reject = DelayedPromise.noop;

    this.promise = new Promise<Type>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  private static noop() {
    throw new Error(
      "The noop function was called from the DelayedPromise, which was not supposed to happen",
    );
  }
}
